import { appConfig as $config } from '../../app.config';
import { ValidationRules } from '../ValidationRules';
import { ColorCarousel } from '../ColorCarousel';
import { UI } from '../UI';
import { App } from '../App';

import './scss/sendsample.scss';

export const SendSample = (function () {
  let dialog = ({ data = {}, ok = () => {}, lastQuery = {} }) => {
    window['DT'].senSampleSelectColr = '';
    $.each(data.variants, function (k, v) {
      v.approved = k == 0;
      if (v.approved) {
        window['DT'].senSampleSelectColr = v.color;
      }
    });

    window['DT'].senSampleSelectSize = data.availableSizes ? data.availableSizes : '';

    console.log(data);
    let template = require('./tmpl/sendSample.hbs');
    bootbox
      .dialog({
        title: data.title,
        message: template({ prelisting: data, $lang: $lang }),
        size: 'lg',
        className: 'modal-scrolled-content',
        buttons: {
          Ok: {
            label: `<i class="fal fa-upload"></i> ${$lang.btn.SendSample}`,
            className: 'btn btn-primary',
            callback: (e) => {
              sendSample(e, ok, lastQuery);
              return false;
            }
          },
          Close: {
            label: `<i class="fal fa-times"></i> ${$lang.btn.close}`,
            className: 'btn btn-default'
          }
        }
      })
      .init(() => {
        sendSampleDialoginit(data);
      });
  };

  let sendSampleDialoginit = (prelisting) => {
    let dialog = $('#sendSampleDialog');
    dialog.validate({ rules: ValidationRules.sendSampleDialog });

    let subItems = [];

    let throttledBrandRequest = _.debounce(function (query, processSync, processAsync) {
      return $.ajax({
        url: `${$config.apiURL}/Autocompele/get?propertyName=country&term=${query}`,
        type: 'get',
        dataType: 'json',
        success: function (res) {
          var brandOpt = [];
          subItems = [];
          var subBrandOpt = [];
          for (var i = 0; i < res.items.length; i++) {
            brandOpt.push(res.items[i].propertyValue);
            var item = { parent: res.items[i].propertyValue, items: [] };
            for (var j = 0; j < res.items[i].subEntities.length; j++) {
              item.items.push(res.items[i].subEntities[j].propertyValue);
              subBrandOpt.push(res.items[i].subEntities[j].propertyValue);
            }
            subItems.push(item);
          }
          return processAsync(brandOpt);
        }
      });
    }, 300);

    $('.size', dialog).on('click', (e) => {
      let el = $(e.currentTarget);
      let data = el.data();
      $('.size', dialog).removeClass('select');
      el.addClass('select');
      window['DT'].senSampleSelectSize = data.size;
    });

    $('[name="country"]', dialog).typeahead(
      {
        hint: true,
        highlight: true,
        minLength: 1
      },
      {
        name: 'brand',
        async: true,
        source: function (query, processSync, processAsync) {
          throttledBrandRequest(query, processSync, processAsync);
        },
        templates: {
          empty: '<div>no result</div>',
          pending: '<div>Please wait...</div>'
        }
      }
    );

    $('[name="city"]', dialog).typeahead(
      {
        hint: true,
        highlight: true,
        minLength: 1
      },
      {
        limit: 'Infinity',
        name: 'subBrand',
        source: function (query, process) {
          let result = [];
          for (let i = 0; i < subItems.length; i++) {
            if (subItems[i].parent == $('[name="country"]').val()) {
              result = subItems[i].items;
              break;
            }
          }

          let items = [];
          let searchingTerm = query.toLowerCase();
          for (let i = 0; i < result.length; i++) {
            if (result[i].toLowerCase().indexOf(searchingTerm) === 0) {
              items.push(result[i]);
            }
          }

          return process(items);
        },
        templates: {
          empty: '<div>no result</div>',
          pending: '<div>Please wait...</div>'
        }
      }
    );

    $('[name="country"]').bind('typeahead:change', function (ev, suggestion) {
      setTimeout(function () {
        $('[name="city"]').typeahead('val', '');
      }, 100);
    });

    ColorCarousel.init('#sendSampleDialog');

    $(`#colors-carousel-${prelisting.id} .item-color-checkbox`, dialog).each((k, v) => {
      $(v).change(function () {
        $(`#colors-carousel-${prelisting.id} .item-color-checkbox`, dialog).prop('checked', false);
        this.checked = true;
        window['DT'].senSampleSelectColr = $(this).attr('name');
        var imageUrl = $(this).parents('[data-image]').data('image');
        $('.img-box', dialog).children('div').css('background-image', `url(${imageUrl})`);
      });
    });

    $('[name=phone]', dialog).mask('(999) 999-9999');
    $('[name=postalAddress]', dialog).mask('99999');
  };

  let sendSample = (e, ok, lastQuery) => {
    let $form = $('#sendSampleDialog');

    if (!$form.valid()) {
      $('.form-control.is-invalid').focus();
      return false;
    }

    let formData = $form.serializeObject();

    if (Object.prototype.toString.call(window['DT'].senSampleSelectSize) == '[object Array]') {
      formData.size = window['DT'].senSampleSelectSize[0];
    } else {
      formData.size = window['DT'].senSampleSelectSize;
    }

    formData.color = window['DT'].senSampleSelectColr;
    UI.btn.spinnerRight(e.target);
    UI.block('#sendSampleDialog');

    $.when(App.ajaxData('prelistings/sendSample', formData, 'POST')).done((res) => {
      if (!res.succeeded) {
        return UI.errorMessage(res.errorInformation.errorReason);
      }
      bootbox.hideAll();
      UI.notify({
        text: $lang.alert.SuccessfullySend,
        icon: 'fal fa-check-circle',
        type: 'success'
      });

      UI.unblock('#sendSampleDialog');
    });

    // return false;
  };

  return {
    dialog
  };
})();
